/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 10.09.2016.
 */

import React, {Component, PropTypes} from 'react';
//import {connect} from 'react-redux';
//import {bindActionCreators} from 'redux';

import Platform from 'platform';
import ClassNames from 'classnames';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

import Translate from '../../../components/Translate';

import {ACTIONS} from '../index';

export const STATES = {
  'IDLE': 'idle',
  'PLAYING': 'playing'
};

class YoutubePlayer extends Component {
  constructor(props) {
    super(props);

    this.player = null;
    this.tag = null;

    this.state = {
      //state: STATES.IDLE,
      isInit: false,
      isError: false,
      errorMsg: ''
    };
  }

  componentDidMount() {

    this.setState({
      isError: false,
      errorMsg: ''
    });

    this.__processAction();
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(newProps.player, this.props.player)) {
      this.setState({
        isError: false,
        errorMsg: ''
      });

      this.__processAction(newProps);
    }
  }

  componentWillUnmount() {

    this.player && this.player.destroy();
  }

  __processAction(props = this.props) {

    switch (props.player.action) {
      case ACTIONS.OPEN:

        if (!this.state.isInit) {

          this._initPlayer(props.player);
        } else {

          this._loadVideo(props.player.stream_url);
        }

        break;

      case ACTIONS.CLOSE:

        this.Stop();
        this.SetSize(null, null);

        break;

      case ACTIONS.RESIZE_DETACHED:

        this.SetSize(props.player.width, props.player.height);

        break;
    }
  }

  _initPlayer(opt) {
    this.setState({isInit: true});

    let params = {
      height: '270',
      width: '460',
      events: {
        'onReady': this._onPlayerReady.bind(this),
        'onStateChange': this._onPlayerStateChange.bind(this),
        'onError': this._onError.bind(this)
      }
    };

    if (opt.stream_url.indexOf('list=') !== -1) {

      params.playerVars = {
        listType: 'playlist',
        list: opt.stream_url.split('list=')[1],
        modestbranding: 1,
        color: 'white',
        rel: 0
      };
    } else {

      params.videoId = opt.stream_url;
      params.playerVars = {
        modestbranding: 1,
        color: 'white',
        rel: 0
      };
    }

    if (window.YT) {

      this.player = new YT.Player('youtube_player', params);
    } else {

      this.setState({
        isError: true,
        errorMsg: 'Youtube provider not found'
      })
    }
  }

  _loadVideo(videoId) {
    if (videoId.indexOf('list=') !== -1) {

      this.player && this.player.loadPlaylist( videoId.split('list=')[1]);
    } else {

      this.player && this.player.loadVideoById(videoId, 0, 'large');
    }
  }

  SetSize(width, height) {

    this.player && this.player.setSize(width || 460, height || 270);
  }

  Stop() {

    this.player && this.player.stopVideo();
  }

  _onPlayerReady(event) {

    event.target.playVideo();
  };

  _onPlayerStateChange(event) {

    //console.log(event.data);
  }

  _onError(event) {

    this.setState({
      isError: true,
      errorMsg: ('Error code: ' + event.data) || 'Unknown youtube error'
    })
  }

  render() {

    const noSignalClass = ClassNames({
      'show': this.state.isError,
      'player-no-signal crow no-gutter': true
    });

    return (<div>
      <div id="player_no_signal" className={noSignalClass}>
        <p className="p no-signal-text"><Translate content="player.youtube_connection_error" /></p>
        <p className="p player-error-text"> {this.state.errorMsg} </p>
      </div>
      <div id="youtube_player"></div>
    </div>);
  }
}

YoutubePlayer.propTypes = {
  player: PropTypes.object.isRequired
};

//const mapStateToProps = () => {
//
//  return {};
//};
//
//const mapDispatchToProps = (dispatch) => {
//
//  return bindActionCreators({SetBookmark}, dispatch);
//};

export default YoutubePlayer;



// WEBPACK FOOTER //
// ./src/containers/Player/YoutubePlayer/youtube-player.js